import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-our-support-information',
  templateUrl: './our-support-information.component.html',
  styleUrls: ['./our-support-information.component.scss']
})
export class OurSupportInformationComponent implements OnInit {
  @Input() informationData;
  informationForm: FormGroup;
  existsSubtitle: boolean = true;
  // File variables
  fileImg64: string | ArrayBuffer;
  wrongSize: any[] = [];
  maxLength = 1500;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.informationForm = this.fb.group({
      title: [(this.informationData ? this.informationData.title : null), [Validators.required]],
      subTitle: [(this.informationData ? this.informationData.subTitle : null)],
      orderId:  [(this.informationData ? this.informationData.orderId : null)],
      img: [(this.informationData ? this.informationData.img : null), [Validators.required]],
      img64: [(this.informationData ? this.informationData.img : null), [Validators.required]],
      img64Upload: [false],
    });

    if (this.informationData && this.informationData.subTitle) {
      this.informationForm.get('subTitle').setValidators([Validators.required]);
    } else {
      this.existsSubtitle = false;
    }

    if (this.informationData && this.informationData.id && !this.informationData.onlyImage) {
      this.informationForm.get('img').setValidators(null);
      this.informationForm.get('img64').setValidators(null);
    }

    if (this.informationData.onlyImage) {
      this.informationForm.get('title').setValidators(null);
    }

    if (this.informationData && this.informationData.id && !this.informationData.onlyImage) {
      this.informationForm.get('img').setValidators(null);
      this.informationForm.get('img64').setValidators(null);
      this.informationForm.get('img64Upload').setValidators([Validators.required]);
    }
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        this.wrongSize['i'] = null;
        this.fileImg64 = image.src;
        this.informationForm.get('img').setValue((event.target.files[0]).name);
        this.informationForm.get('img64').setValue(this.fileImg64.split(',')[1]);
        this.informationForm.get('img64Upload').setValue(true);
      };
    };
    reader.onerror = (error) => {
    };
  }

  isValid(): void {
    const dataToSend = this.informationForm.value;
    dataToSend.id = this.informationData.id;
    if (this.informationData && !this.informationData.subTitle) {
      delete dataToSend.subTitle;
    }

    if (this.informationData.onlyImage) {
      delete dataToSend.title;
      delete dataToSend.subTitle;
      dataToSend.id = this.informationData.id;
      dataToSend.codeImg = 2;
    }

    if (! this.informationData.onlyImage) {
      delete dataToSend.img;
      delete dataToSend.img64;
      delete dataToSend.img64Upload;
    }

    delete dataToSend.operativeMode;
    this.activeModal.close(dataToSend);
  }
}
